import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { Box } from '../../Box/index.js';
import { useResponsiveCss } from './useResponsiveCss.js';

var ResponsiveCss = function (_a) {
    var sxProp = _a.sx, cssProp = _a.cssProp, match = _a.match, max = _a.max, min = _a.min, notMatch = _a.notMatch, useDisplay = _a.useDisplay, props = __rest(_a, ["sx", "cssProp", "match", "max", "min", "notMatch", "useDisplay"]);
    var sx = useResponsiveCss({
        cssProp: cssProp,
        match: match,
        max: max,
        min: min,
        notMatch: notMatch,
        useDisplay: useDisplay,
        sx: sxProp,
    });
    return jsx(Box, __assign({ sx: sx }, props));
};

export { ResponsiveCss };
//# sourceMappingURL=index.js.map
